import React, { useState } from 'react';
import { Grid, Box, Typography, Divider, Radio, RadioGroup } from '@mui/material';
import Select from "react-select";
import { makeStyles } from '@mui/styles';
import DeduplicatePhysiciansTable from './deduplicatePhysiciansTable';
import ConnectedApps from './connectedApps';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getCampaignIngestion, updateCampaigningestion, updateCampaignGeneration } from '../../../redux/thunks/campaignThunks';
import {getSelectedCampaignChannels, getSelectedCampaignPartners } from '../../../redux/thunks/campaignThunks'

import { CrossCircleIcon } from '../../../assets';
import { actions as channelAction } from '../../../redux/reducers/channelReducer';
import { addOrRemoveSelectedPartner, getPartners } from '../../../redux/thunks/partnerThunk';
import { addOrRemoveSelectedChannel, getChannels } from '../../../redux/thunks/channelThunk';
import { CustomAccordion, CustomReactSelect } from '../../shared';

const useStyles = makeStyles({
    root: {
        '&$checked': {
            color: '#8C3F7D',
        },
    },
    checked: {},
});

function CustomerSettingsPanel(props) {
    const { } = props;
    const classes = useStyles();
    const [selectedVendor, setSelectedVendor] = useState([]);
    const dispatch = useDispatch()
    const { company } = useSelector((state) => state.company);
    const { availablePartners, isPartnerSelected } = useSelector((state) => state.partner)
    const { availablechannels, selectedChannel, isChannelSelected } = useSelector((state) => state.channel)
    const {  INGESTION_TYPES,CAMPAIGN_GENERATION_TYPES, } = useSelector((state) => state.customerSettings);
    const { campaignGenerationType, partners, channels,selectedIngestion } = useSelector((state) => state.campaign);
    const handleOptionChange = (event) => {
        dispatch(updateCampaignGeneration({companyId: company.id, selected: event.target.value?.toUpperCase()}))
    };

    const handleIngestionChange = (event) => {
        dispatch(updateCampaigningestion({companyId:company.id,selected:event.target.value}))
    };

    const handleBoxIngestion =(id) =>{
        dispatch(updateCampaigningestion({companyId:company.id,selected:id}))
    }

    const handleOptionClick = (value) => {
        dispatch(updateCampaignGeneration({companyId: company.id, selected: value?.toUpperCase()}))
    };

    const handleVendorChange = (selectedOption) => {
        dispatch(addOrRemoveSelectedPartner({companyId: company.id, partnerId: selectedOption.value, addRemove: 1}))
    };

    const handleRemoveVendor = (removedOption) => {
        dispatch(addOrRemoveSelectedPartner({companyId: company.id, partnerId: removedOption.id, addRemove: 0}))
        const updatedValues = selectedVendor.filter((option) => option.value !== removedOption.value);
        setSelectedVendor(updatedValues);
    };

    const handleChannelChange = (selectedOption) => {
        dispatch(channelAction.handleChannelChange({selected: selectedOption}))
        dispatch(addOrRemoveSelectedChannel({companyId: company.id, channelId: selectedOption.value, addRemove: 1}))
    };

    const handleRemoveChannel = (removedOption) => {
        dispatch(addOrRemoveSelectedChannel({companyId: company.id, channelId: removedOption.id, addRemove: 0}))
    };

    useEffect(() => {
        if(company.id){
            dispatch(getCampaignIngestion({ companyId: company.id }))
            dispatch(getPartners({ companyId: company.id }))
            dispatch(getChannels({ companyId: company.id }))
            dispatch(getSelectedCampaignChannels({ companyId: company.id }))
            dispatch(getSelectedCampaignPartners({ companyId: company.id }))
        }
    },[company.id, dispatch])

    useEffect(() => {
        if(isChannelSelected>0){
            dispatch(getSelectedCampaignChannels({ companyId: company.id }))
            dispatch(getChannels({ companyId: company.id }))
        }
    },[isChannelSelected])

    useEffect(() => {
        if(isPartnerSelected>0){
            dispatch(getSelectedCampaignPartners({ companyId: company.id }))
            dispatch(getPartners({ companyId: company.id }))
        }
    },[isPartnerSelected])
    
    const renderChannels = () => {
    
        return channels?.map(channel => {
          return (<Box className="br-16px bg-primary-50 padding-10px">
            <Box className="flex-row-center gap-8">
              <Typography className="text-sm-medium gray-900">
                {channel.name}
              </Typography>
              <Box className='icon' onClick={() => handleRemoveChannel(channel)}>
                <img src={CrossCircleIcon} alt={channel} />
              </Box>
            </Box>
          </Box>)
        })
      };

      const renderPartners = () => {
    
        return partners?.map(partner => {
          return (<Box className="br-16px bg-primary-50 padding-10px">
            <Box className="flex-row-center gap-8">
              <Typography className="text-sm-medium gray-900">
                {partner.name}
              </Typography>
              <Box className='icon' onClick={() => handleRemoveVendor(partner)}>
                <img src={CrossCircleIcon} alt={partner} />
              </Box>
            </Box>
          </Box>)
        })
      };

    const renderCampgainGenerationType = () => {

        return (
            <Grid item xs={12}>
                <Grid container spacing={'32px'} className="flex-row">
                    <Grid item xs={4}>
                        <Box>
                            <Typography className="text-sm-medium gray-700">
                                Campaign Generation Type
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={8}>
                        <RadioGroup
                            value={campaignGenerationType?.toLowerCase()}
                            className='flex-column gap-12'
                        >
                            {CAMPAIGN_GENERATION_TYPES?.map((type, index) => {
                                return (<Box
                                    key={type + index}
                                    onClick={() => handleOptionClick(type?.toLowerCase())}
                                    className={`custom-radio-container ${campaignGenerationType?.toLowerCase() === type?.toLowerCase() && 'bg-primary-50 custom-radio-selected-border'}`}
                                >
                                    <Radio
                                        classes={classes}
                                        value={type?.toLowerCase()}
                                        onChange={(event) => { event.stopPropagation(), handleOptionChange }}
                                        sx={{
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 16,
                                            },
                                        }}
                                    />
                                    <Typography className={`text-sm-medium ${campaignGenerationType?.toLowerCase() === type?.toLowerCase() ? 'primary-800' : 'gray-700'}`}>
                                        {type}
                                    </Typography>
                                </Box>)
                            }
                            )}
                        </RadioGroup>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    const renderIngestionType = () => {
        return (
            <Grid item xs={12}>
                <Grid container spacing={'32px'} className="flex-row">
                    <Grid item xs={4}>
                        <Box>
                            <Typography className="text-sm-medium gray-700">
                                Ingestion Type
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={8}>
                        <RadioGroup
                            value={selectedIngestion}
                            className='flex-column gap-12'
                        >
                            {INGESTION_TYPES?.map((ingestion, index) => {
                                let { id, type, text } = ingestion;
                                return (<Box
                                    key={type + index}
                                    onClick={() => handleBoxIngestion(id)}
                                    className={`custom-radio-container ${selectedIngestion === id && 'bg-primary-50 custom-radio-selected-border'}`}
                                >
                                    <Radio
                                        classes={classes}
                                        value={id}
                                        onChange={(event) => { event.stopPropagation(), handleIngestionChange }}
                                        sx={{
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 16,
                                            },
                                        }}
                                    />
                                    <Box className="flex-column-start-center">
                                        <Typography className={`text-sm-medium ${selectedIngestion === id ? 'primary-800' : 'gray-700'}`}>
                                            {type}
                                        </Typography>
                                        <Typography className={`text-sm-regular ${selectedIngestion === id ? 'primary-600' : 'gray-500'}`}>
                                            {text}
                                        </Typography>
                                    </Box>
                                </Box>)
                            }
                            )}
                        </RadioGroup>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    const renderChannel = () => {
        return (
            <Grid item xs={12}>
                <Grid container spacing={'32px'} className="flex-row">
                    <Grid item xs={6}>
                        <Box>
                            <Typography className="text-sm-medium gray-700">
                                Channels
                            </Typography>
                        </Box>
                        <Box className="flex-row-wrap gap-8 pb-20px">{renderChannels()}</Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box className="max-width-70">
                            <CustomReactSelect
                                placeholder="Select Channel"
                                selectedOption={selectedChannel}
                                options={availablechannels}
                                handleFilter={handleChannelChange}
                                isOptionsSearchable={true}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        )
}
    const renderPartner = () => {
        return (
            <Grid item xs={12}>
                <Grid container spacing={'32px'} className="flex-row">
                    <Grid item xs={6}>
                        <Box>
                            <Typography className="text-sm-medium gray-700">
                                Vendors
                            </Typography>
                        </Box>
                        <Box className="flex-row-wrap gap-8 pb-20px">{renderPartners()}</Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box className="max-width-70">
                            <CustomReactSelect
                                placeholder="Select Vendor"
                                selectedOption={selectedVendor}
                                options={availablePartners}
                                handleFilter={handleVendorChange}
                                isOptionsSearchable={true}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    const renderDeduplication = () =>{
        return (
            <Grid item xs={12}>
            <DeduplicatePhysiciansTable />
        </Grid>
        )
    }

    const renderConnectedApps = () =>{
        return (
            <Grid item xs={12}>
            <ConnectedApps />
        </Grid>
        )
    }
    return (
        <Grid
            container
            className="flex-row"
            spacing={'24px'}
        >
            {/* Campaign Settings */}
            <Grid item xs={12}>
                <Box className="flex-column gap-4">
                    <Typography className="text-lg-medium gray-900">
                        Campaign Settings
                    </Typography>
                </Box>
            </Grid>

            {/* Campaign Generation Type */}
            <Box className="w-100 mb-3 mt-3 pl-24px">
            <CustomAccordion
             title="Campaign Generation Type"
             component={renderCampgainGenerationType()}
             accordionContainerBackground="bg-primary-50"
             accordionTitleColor="primary-color"
             acoordianDetailsBackground="bg-gray-50"
             byDefaultOpen={false}
             acoordianDetailsPadding="padding-24px"
            />
            </Box>
           
            {/* Ingestion Type */}
            <Box className="w-100 mb-3 pl-24px">
            <CustomAccordion
             title="Ingestion Type"
             component={renderIngestionType()}
             accordionContainerBackground="bg-primary-50"
             accordionTitleColor="primary-color"
             acoordianDetailsBackground="bg-gray-50"
             byDefaultOpen={false}
             acoordianDetailsPadding="padding-24px"
            />
            </Box>
            
            {/* Channels */}
            <Box className="w-100 mb-3 pl-24px">
            <CustomAccordion
             title="Channels"
             component={renderChannel()}
             accordionContainerBackground="bg-primary-50"
             accordionTitleColor="primary-color"
             acoordianDetailsBackground="bg-gray-50"
             byDefaultOpen={false}
             acoordianDetailsPadding="padding-24px"
            />
            </Box>
           
            {/* Vendors */}
            <Box className="w-100 mb-3 pl-24px">
            <CustomAccordion
             title="Vendors"
             component={renderPartner()}
             accordionContainerBackground="bg-primary-50"
             accordionTitleColor="primary-color"
             acoordianDetailsBackground="bg-gray-50"
             byDefaultOpen={false}
             acoordianDetailsPadding="padding-24px"
            />
            </Box>
            
            {/* Deduplicate Physicians Across a Certain Time Period */}
            <Box className="w-100 mb-3 pl-24px">
            <CustomAccordion
             title="Deduplicate Physicians Across a Certain Time Period"
             component={renderDeduplication()}
             accordionContainerBackground="bg-primary-50"
             accordionTitleColor="primary-color"
             acoordianDetailsBackground="bg-gray-50"
             byDefaultOpen={false}
             padding="pt-10px"
            />
            </Box>
            
            {/* Connected Apps */}
            <Box className="w-100 mb-3 pl-24px">
            <CustomAccordion
             title="Connected apps"
             component={renderConnectedApps()}
             accordionContainerBackground="bg-primary-50"
             accordionTitleColor="primary-color"
             acoordianDetailsBackground="bg-gray-50"
             byDefaultOpen={false}
             acoordianDetailsPadding="padding-24px"
            />
            </Box>
            
        </Grid>
    )
}

export default CustomerSettingsPanel;